// CYR ("Customers choose their preferred reward") Win Odds.
//
// Win Odds is a campaign-level property carried on
// outcome_choices_config.probability as an integer 0-100 = chance of WINNING.
// The backend rolls it once per play (MoveOutcomeOperations#cyr_win?) and never
// consults per-outcome probability for CYR campaigns; an absent value means 100
// (always win). Carrying the odds on the no_outcome row instead left the value
// inert, because the dashboard strips per-outcome probability whenever CYR is on
// (PLA-8790) — that is what QA hit on PLA-8788. — PLA-9059 / perx-api #12634

export const DEFAULT_WIN_PROBABILITY = 100;

// The BE rejects anything that is not an Integer in 0..100
// (Dash::V4::Campaign::Base#validate_outcome_choices_probability).
export const clampWinProbability = (value: any): number => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return DEFAULT_WIN_PROBABILITY;
  return Math.min(100, Math.max(0, Math.round(parsed)));
};

export const deriveWinProbability = (outcomeChoicesConfig: any): string | undefined => {
  const probability = outcomeChoicesConfig?.probability;
  return probability == null ? undefined : String(probability);
};

export const withWinProbability = (outcomeChoicesConfig: any, winProbability: number): any => ({
  ...(outcomeChoicesConfig || {}),
  probability: clampWinProbability(winProbability)
});

// Win Odds only means something for a CYR campaign that can lose, i.e. one
// carrying a no_outcome row. Anywhere else the key must not reach the wire, and
// an untouched Win Odds input stays absent rather than being sent as an
// invented default — the backend reads an absent value as 100 (always win),
// which is what the input displays.
export const prepareWinProbabilityForSubmit = (outcomeChoicesConfig: any, outcomes: any[]): any => {
  const config = { ...(outcomeChoicesConfig || {}) };
  const canLose = (outcomes || []).some(outcome => outcome?.identifier === 'no_outcome');

  if (!config.enabled || !canLose || config.probability == null) {
    delete config.probability;
    return config;
  }

  return { ...config, probability: clampWinProbability(config.probability) };
};
